<template>
  <div>
    <div class="searchContainer">
      <div class="search-item" style="width: 292px; display: inline-block">
        <a-range-picker
          size="large"
          v-model:value="uploadRange"
          :placeholder="['上传开始日期', '上传结束日期']"
          allowClear
          format="YYYY-MM-DD"
          class="search-picker"
          valueFormat="YYYY-MM-DD"
          @change="handleSelectUploadDate"
        />
      </div>
      <div class="search-item" style="width: 342px; display: inline-block">
        <a-range-picker
          size="large"
          v-model:value="auditRange"
          :placeholder="['审核完成开始日期', '审核完成结束日期']"
          allowClear
          format="YYYY-MM-DD"
          class="search-picker"
          valueFormat="YYYY-MM-DD"
          @change="handleSelectAuditDate"
        />
      </div>
      <a-input
        class="search-item"
        size="large"
        v-model:value="paramQuery.workOrderIds"
        placeholder="请输入工单ID"
        @input="inputFormat($event, 'workOrderIds', 4)"
        allowClear
        :maxlength="19"
      />
      <a-select
        class="search-item"
        v-model:value="paramQuery.workOrderTypes"
        placeholder="请选择工单类型"
        size="large"
        allowClear
      >
        <a-select-option
          v-for="option in workOrderType"
          :value="option.eventType"
          :key="option.eventType"
        >
          {{ option.eventTypeContent }}
        </a-select-option>
      </a-select>
      <a-input
        class="search-item"
        size="large"
        v-model:value="paramQuery.daName"
        placeholder="请输入健管姓名"
        :maxlength="19"
        allowClear
      />
      <a-input
        class="search-item"
        size="large"
        v-model:value="paramQuery.dptName"
        placeholder="请输入宣广处"
        :maxlength="19"
        allowClear
      />
      <a-input
        class="search-item"
        size="large"
        v-model:value="paramQuery.branchCompanyName"
        placeholder="请输入分公司"
        :maxlength="19"
        allowClear
      />
      <a-input
        class="search-item"
        size="large"
        v-model:value="paramQuery.majorAreaName"
        placeholder="请输入大区"
        :maxlength="19"
        allowClear
      />
      <a-button size="large" @click="handleSearch(true)" class="search-btn" type="primary">
        搜索
      </a-button>
      <a-button size="large" @click="handleReset" class="search-btn">重置</a-button>
    </div>
    <a-row type="flex" justify="end">
      <a-button
        v-if="isAdmin"
        size="large"
        style="float: right; background: #60d195; color: #fff; border-color: #60d195"
        @click="emits('importExcel')"
        class="search-download"
      >
        上传
      </a-button>
      <a-button
        size="large"
        type="primary"
        style="float: right"
        :loading="exportLoading"
        @click="handleSearch(false)"
        class="search-export"
      >
        导出
      </a-button>
    </a-row>
  </div>
</template>

<script setup>
import { ref, reactive, defineEmits, defineProps, computed, watch } from 'vue'
import { inputRule } from '@/utils/validate'
import { formatDateForFilter } from '@/utils'
import workOrderType from '@/views/hooks/workorderType'
import moment from 'moment'
import { cloneDeep } from 'lodash-es'

const emits = defineEmits(['changeQuery', 'exportQuery', 'importExcel'])
const props = defineProps({
  queryParams: {
    type: Object,
    default: () => ({})
  },
  exportLoading: {
    type: Boolean,
    default: false
  }
})

const store = useStore()
import { useStore } from 'vuex'
const isAdmin = computed(() => store.state.user.isAdmin)

const defaultQuery = reactive({
  workOrderIds: null,
  daName: null,
  createdAtMin: null,
  createdAtMax: null,
  auditTimeMin: null,
  auditTimeMax: null,
  workOrderTypes: null,
  dptName: null,
  branchCompanyName: null,
  majorAreaName: null
})

const initDate = [
  moment().subtract(1, 'months').format('YYYY-MM-DD 00:00:00'),
  moment().format('YYYY-MM-DD 23:59:59')
]
const defaultCreateRange = ref([...initDate])
const uploadRange = ref([...initDate])
const auditRange = ref([])
const paramQuery = reactive({
  ...defaultQuery,
  createdAtMin: defaultCreateRange.value[0],
  createdAtMax: defaultCreateRange.value[1]
})

function inputFormat(e, key, type) {
  paramQuery[key] = inputRule(e.target.value, type)
}

const handleSelectUploadDate = e => {
  const [start, end] = formatDateForFilter(uploadRange.value, true)
  paramQuery.createdAtMin = start ? start + ' 00:00:00' : null
  paramQuery.createdAtMax = end ? end + ' 23:59:59' : null
}

const handleSelectAuditDate = e => {
  const [start, end] = formatDateForFilter(auditRange.value, true)
  paramQuery.auditTimeMin = start ? start + ' 00:00:00' : null
  paramQuery.auditTimeMax = end ? end + ' 23:59:59' : null
}

const handleSearch = type => {
  for (const key in paramQuery) {
    if (!paramQuery[key]) {
      paramQuery[key] = null
    }
  }
  type ? emits('changeQuery', cloneDeep(paramQuery)) : emits('exportQuery', cloneDeep(paramQuery))
}

const handleReset = () => {
  uploadRange.value = [...initDate]
  auditRange.value = []
  Object.assign(paramQuery, defaultQuery, {
    createdAtMin: initDate[0],
    createdAtMax: initDate[1]
  })
  emits('changeQuery', cloneDeep(paramQuery))
}

watch(
  () => props.queryParams,
  value => {
    const nextQuery = {
      ...defaultQuery,
      ...cloneDeep(value || {})
    }
    Object.assign(paramQuery, nextQuery)

    const createdRange = [nextQuery.createdAtMin, nextQuery.createdAtMax].filter(Boolean)
    const auditTimeRange = [nextQuery.auditTimeMin, nextQuery.auditTimeMax].filter(Boolean)

    uploadRange.value = createdRange.length === 2 ? createdRange : [...initDate]
    auditRange.value = auditTimeRange.length === 2 ? auditTimeRange : []
  },
  {
    immediate: true,
    deep: true
  }
)
</script>

<style lang="scss" scoped>
.searchContainer {
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 10px 20px 0px;

  .search-item {
    width: 224px;
    margin: 0 12px 10px 0;
  }
  .search-date {
    width: 280px;
  }
  .search-btn {
    width: 80px;
    margin: 0px 12px 10px 0;
  }
}
.search-download,
.search-export {
  margin: 20px 20px 10px 0px;
}

.search-download:hover,
.search-download:focus {
  border-color: #60d195;
}
</style>
